import styles from "./JourneyShellSkeleton.module.css";

export function JourneyShellSkeleton() {
	return (
		<div
			className={styles.skeleton}
			role="status"
			aria-busy="true"
			aria-label="Loading journey"
		>
			<div className={styles.headerRow}>
				<div className={styles.circle} />
				<div className={styles.titleBlock}>
					<div className={styles.titleBar} />
					<div className={styles.subBar1} />
					<div className={styles.subBar2} />
				</div>
			</div>
			<div className={styles.divider} />
			<div className={styles.stepsHeader}>
				<div className={styles.headingBar} />
				<div className={styles.subtitleBar} />
			</div>
			<div className={styles.pillRow}>
				<div className={`${styles.pill} ${styles.pill1}`} />
				<div className={`${styles.pill} ${styles.pill2}`} />
				<div className={`${styles.pill} ${styles.pill3}`} />
				<div className={`${styles.pill} ${styles.pill4}`} />
				<div className={`${styles.pill} ${styles.pill5}`} />
			</div>
			<div className={styles.divider} />
		</div>
	);
}
